import React from 'react';
import { Breadcrumb, BreadcrumbItem } from '@/components/Breadcrumb';

interface PageHeaderProps {
  title: string;
  breadcrumbs?: BreadcrumbItem[];
  actions?: React.ReactNode;
  description?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, breadcrumbs, actions, description }) => {
  return (
    <div className="mb-6">
      {breadcrumbs && breadcrumbs.length > 0 && (
        <div className="md:hidden mb-3">
          <Breadcrumb items={breadcrumbs} />
        </div>
      )}

      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 md:gap-4">
        <div>
          <h1 className="text-lg md:text-2xl font-bold text-gray-900 dark:text-white">{title}</h1>
          {description && (
            <p className="text-sm md:text-base text-gray-600 dark:text-gray-400 mt-1">{description}</p>
          )}
        </div>
        <div className="flex items-center gap-4">
          {breadcrumbs && breadcrumbs.length > 0 && (
            <div className="hidden md:block">
              <Breadcrumb items={breadcrumbs} />
            </div>
          )}
          {actions && <div>{actions}</div>}
        </div>
      </div>
    </div>
  );
};
